'use strict';

(function () {
	'use strict';

	// Usage:
	// 
	// Creates:
	// 

	FiscalDataController.$inject = ['$q', '$translate', 'download', 'fiscalService'];
	angular.module('app.open-data').component('fiscalData', {
		require: { app: "^app" },
		template: '<div style="padding: 2em 2em;"><div class="container-fluid" translate-namespace="fiscal-data"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><ol class="breadcrumb pull-left"><li ng-repeat="breadcrumb in $ctrl.app.breadcrumbs"><a href="{{breadcrumb.url}}">{{breadcrumb.label}}</a></li><li><a ui-sref="open-data" translate-namespace="open-data" translate>.Municipal open data</a></li><li translate>.Fiscal data</li></ol><div class="pull-right"><login-widget></login-widget></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-mg-3 col-lg-3"><aside class="well well-sidebar"><div class="row"><div class="col-lg-12"><div class="form-group"><div class="btn-group btn-group-justified"><label class="btn btn-default" ng-model="$ctrl.formFields.dataType" ng-change="$ctrl.onDataTypeChange()" uib-btn-radio="$ctrl.dataTypeOptions.revenue" translate>.Revenue</label> <label class="btn btn-default" ng-model="$ctrl.formFields.dataType" ng-change="$ctrl.onDataTypeChange()" uib-btn-radio="$ctrl.dataTypeOptions.expenses" translate>.Expenses</label></div></div></div><div class="col-lg-6"><div class="form-group"><label for="form-field-from-date" translate>.Start Year</label><div class="input-group input-group-sm"><input id="form-field-from-date" type="text" class="form-control" uib-datepicker-popup="yyyy" is-open="$ctrl.uiConfig.from.isOpen" datepicker-options="$ctrl.uiConfig.from.options" ng-model="$ctrl.formFields.from" show-button-bar="false" ng-click="$ctrl.uiConfig.from.open()" ng-change="$ctrl.onDateChange()" readonly> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="$ctrl.uiConfig.from.open()"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="col-lg-6"><div class="form-group"><label for="form-field-to-date" translate>.End Year</label><div class="input-group input-group-sm"><input id="form-field-to-date" type="text" class="form-control" uib-datepicker-popup="yyyy" is-open="$ctrl.uiConfig.to.isOpen" datepicker-options="$ctrl.uiConfig.to.options" ng-model="$ctrl.formFields.to" show-button-bar="false" ng-click="$ctrl.uiConfig.to.open()" ng-change="$ctrl.onDateChange()" readonly> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="$ctrl.uiConfig.to.open()"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="col-lg-12"><div class="form-group"><button type="button" class="btn btn-default btn-block" ng-model="$ctrl.formFields.showAnalysis" ng-change="$ctrl.onShowAnalysisChange()" uib-btn-checkbox btn-checkbox-true="0" btn-checkbox-false="1"><span ng-if="!$ctrl.formFields.showAnalysis" translate>.Show analysis</span> <span ng-if="$ctrl.formFields.showAnalysis" translate>.Hide analysis</span></button></div></div><div class="col-lg-12"><div class="btn-group btn-block" role="group" translate-namespace="open-data.download-button"><button type="button" class="btn btn-block btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><span translate>.Download</span> <span class="caret"></span></button><ul class="dropdown-menu"><li><a data-ng-click="$ctrl.downloadChartData()" translate>.CSV file</a></li><li><a data-ng-click="$ctrl.downloadChart(\'png\')" translate>.Image</a></li><li><a data-ng-click="$ctrl.downloadChart(\'svg\')" translate>.Vector image</a></li></ul></div></div></div></aside></div><div class="col-xs-12 col-sm-12 col-mg-12 col-lg-9"><div class="panel panel-default panel-graph"><h4 class="text-center">{{$ctrl.uiConfig.chart.title.text}}</h4><style>\n						.breadcrumb {\n							/* font-size: 12px; */\n							background: transparent;\n						}\n						.breadcrumb>li+li:before {\n							content: "\\00bb";\n						}\n						.breadcrumb .btn-group li {\n							font-size: 12px;\n						}\n					</style><ol class="breadcrumb text-center"><li ng-repeat="path in $ctrl.formFields.codesPath"><div class="btn-group btn-group-xs" ng-if="path.level.children.length || path.level.depth <= $ctrl.maxDepth"><button class="btn btn-default dropdown-toggle" type="button" title="{{path.selected.title}}" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true"><span ng-if="path.selected" class="text-uppercase">{{path.selected.title}}</span> <span ng-if="!path.selected">All Codes</span> <span ng-if="path.level.children.length" class="caret"></span></button><ul class="dropdown-menu" uib-dropdown-menu role="menu" aria-labelledby="single-button"><li role="menuitem text-lowercase"><a ng-click="$ctrl.onCodeChange(path.level)">All Codes</a></li><li></li><li role="menuitem text-capitalize" ng-repeat="child in path.level.children"><a ng-click="$ctrl.onCodeChange(child)" class="text-uppercase">{{child.title | lowercase}}</a></li></ul></div><span ng-if="!path.level.children.length || path.level.depth > $ctrl.maxDepth" class="btn btn-xs btn-default" disabled>All Codes</span></li></ol><nvd3 id="chart" options="$ctrl.uiConfig.chart" data="$ctrl.chart"></nvd3></div></div></div></div></div>',
		controller: FiscalDataController,
		controllerAs: '$ctrl'
	});

	/* @ngInject */
	function FiscalDataController($q, $translate, download, fiscalService) {
		var $ctrl = this;

		////////////////

		/**
   * 
   */
		$ctrl.$onInit = function () {
			$ctrl.maxDepth = 2;

			$ctrl.uiConfig = getUiComponentsConfiguration();

			$ctrl.formFields = {
				dataType: null,
				codesPath: [],
				showAnalysis: true,
				from: moment(),
				to: moment()
			};

			$ctrl.isDataTypeLoaded = { revenue: false, expenses: false };

			/* Initialize form fields */
			$q.all({
				dataTypeOptions: fiscalService.getDataTypes(),
				codeOptions: fiscalService.getCodes($ctrl.maxDepth + 1, true),
				formDefaults: fiscalService.getFormDefaults(),
				yearsRange: fiscalService.getYearRange(),
				translations: getTranslations()
			}).then(function (results) {

				$ctrl.translations = results.translations;
				$ctrl.dataTypeOptions = results.dataTypeOptions;
				$ctrl.yearsRange = results.yearsRange;
				$ctrl.codeOptions = results.codeOptions;

				$ctrl.dataTypeOptions.revenue.title = $ctrl.translations['fiscal-data.Revenue'];
				$ctrl.dataTypeOptions.expenses.title = $ctrl.translations['fiscal-data.Expenses'];

				$ctrl.uiConfig.updateTranslations($ctrl.translations);

				setFormDefaults(results.formDefaults);

				update();
			});
		};

		/**
   * 
   */
		$ctrl.$onChanges = function (changesObj) {};

		/**
   * 
   */
		$ctrl.$onDestroy = function () {};

		/**
   * 
   */
		$ctrl.onCodeChange = function (code) {
			var currentCode = code,
			    previousCode = null,
			    codesPath = [];

			while (currentCode) {
				codesPath.unshift({ level: currentCode, selected: previousCode });
				previousCode = currentCode;
				currentCode = currentCode.parent;
			}

			$ctrl.formFields.codesPath = codesPath;
			refresh();
		};

		/**
   * 
   */
		$ctrl.onYearRangeChange = function () {
			$ctrl.isDataTypeLoaded.revenue = false;
			$ctrl.isDataTypeLoaded.expenses = false;
			update();
		};

		/**
   * 
   */
		$ctrl.onDataTypeChange = function () {
			$ctrl.formFields.codesPath = [{ level: $ctrl.codeOptions[$ctrl.formFields.dataType.name][0], selected: null }];
			update();
		};

		/**
   * 
   */
		$ctrl.onShowAnalysisChange = function () {
			refresh();
		};

		/**
   * @param {*} type
   */
		$ctrl.downloadChart = function (type) {
			var $svg = angular.element('#chart > svg'),
			    renderers = { png: svgAsPngUri, svg: svgAsDataUri };

			renderers[type]($svg[0], { backgroundColor: '#ffffff' }, function (uri) {
				download.fromDataURL(uri, formToFilename(type));
			});
		};

		/**
   * 
   */
		$ctrl.downloadChartData = function () {
			var data = [],
			    codesList,
			    csv;
			var property = $ctrl.formFields.dataType.name === 'revenue' ? 'collected' : 'modulated';

			codesList = fiscalService.flattenCodesTree($ctrl.codeOptions[$ctrl.formFields.dataType.name]);

			codesList.forEach(function (code) {
				var row = [];

				row.push(code.title);
				code.values.forEach(function (value) {
					row.push(value[property]);
				});

				data.push(row);
			});

			csv = Papa.unparse(data, { quotes: true, delimiter: ';' });
			download.fromDataURL("data:text/csv;charset=utf-8,%EF%BB%BF" + encodeURI(csv), formToFilename('csv'));
		};

		/////////////////////////////////////////////////////////////////////////////////////

		/**
   * 
   * @param {*} extension 
   */
		function formToFilename(extension) {
			var _$ctrl$formFields = $ctrl.formFields,
			    dataType = _$ctrl$formFields.dataType,
			    from = _$ctrl$formFields.from,
			    to = _$ctrl$formFields.to;


			return dataType.title + ' from ' + moment(from).format('YYYY') + ' to ' + moment(to).format('YYYY') + '.' + extension;
		}

		/**
   * 
   */
		function getTranslations() {
			return $translate(['fiscal-data.Revenue', 'fiscal-data.Expenses', 'fiscal-data.Stacked', 'fiscal-data.Grouped', 'fiscal-data.Expanded']);
		}

		/**
   * 
   * @param {*} formDefaults 
   */
		function setFormDefaults(formDefaults) {

			$ctrl.formFields.dataType = $ctrl.dataTypeOptions.revenue;

			$ctrl.onDataTypeChange();

			$ctrl.formFields.from = formDefaults.from.toDate();
			$ctrl.formFields.to = formDefaults.to.toDate();
		}

		/**
   * 
   */
		function update() {

			if ($ctrl.isDataTypeLoaded[$ctrl.formFields.dataType.name]) {
				refresh();
				return;
			}

			fiscalService.getCodeEntriesPerFiscalYear($ctrl.formFields.dataType, $ctrl.codeOptions[$ctrl.formFields.dataType.name], $ctrl.formFields.from, $ctrl.formFields.to, $ctrl.maxDepth + 1).then(function (codesEntries) {
				$ctrl.isDataTypeLoaded[$ctrl.formFields.dataType.name] = true;
				refresh();
			});
		}

		/**
   * 
   */
		function refresh() {
			var entries,
			    code,
			    data = [],
			    codes = $ctrl.codeOptions[$ctrl.formFields.dataType.name],
			    codePath = _.last($ctrl.formFields.codesPath);

			code = codePath.selected == null ? codePath.level : codePath.selected;

			entries = [code];
			if ($ctrl.formFields.showAnalysis) {
				if (code.children.length) {
					entries = code.children;
				}
			}

			entries.forEach(function (entry) {
				data.push({ key: entry.title, values: entry.values });
			});
			$ctrl.chart = data;

			$ctrl.uiConfig.chart.title.text = $ctrl.formFields.dataType.title;
			$ctrl.uiConfig.chart.chart.totalLabel = code.title;
		}

		/**
   * 
   */
		function getUiComponentsConfiguration() {

			var locale = {
				"decimal": ",",
				"thousands": '\xA0',
				"grouping": [3],
				"currency": ["", " руб."],
				"dateTime": "%A, %e %B %Y г. %X",
				"date": "%d/%m/%Y",
				"time": "%H:%M:%S",
				"periods": ["AM", "PM"],
				// "days": moment
				"days": moment.weekdays(),
				"shortDays": moment.weekdaysShort(),
				"months": moment.months(),
				"shortMonths": moment.monthsShort()
			};

			var locale = d3.locale(locale);

			var timeFormat = locale.timeFormat.multi([["%Y", function () {
				return true;
			}]]);

			var yFunc = function yFunc(d) {
				var property = $ctrl.formFields.dataType.name === 'revenue' ? 'collected' : 'paid';
				return d.hasOwnProperty(property) ? d[property] : 0;
			};

			return {
				from: {
					isOpen: false,
					options: { minMode: 'year', datepickerMode: 'year', minDate: null, maxDate: null },
					open: function open() {
						this.isOpen = true;
					}
				},
				to: {
					isOpen: false,
					options: { minMode: 'year', datepickerMode: 'year', minDate: null, maxDate: null },
					open: function open() {
						this.isOpen = true;
					}
				},
				updateTranslations: function updateTranslations(translations) {
					this.chart.chart.controlLabels = {
						stacked: translations['fiscal-data.Stacked'],
						stream: translations['fiscal-data.streamed'],
						expanded: translations['fiscal-data.Expanded']
					};

					this.chart.chart.totalLabel = translations['fiscal-data.Total'];
				},
				chart: {

					title: { enable: false },
					subtitle: { enable: false, css: { 'text-transform': 'uppercase' } },

					chart: {
						type: 'stackedAreaChart',
						useInteractiveGuideline: true,

						controlLabels: {},

						height: 550,
						margin: { top: 20, right: 20, bottom: 30, left: 80 },

						useVoronoi: false,
						clipEdge: true,
						duration: 100,

						xScale: d3.time.scale(),
						totalLabel: 'Total',

						x: function x(d) {
							return d.year;
						},
						y: yFunc,

						xAxis: { tickFormat: timeFormat, showMinMax: false },
						yAxis: { tickFormat: d3.format(',.0f') },

						zoom: {
							enabled: false,
							scaleExtent: [1, 10],
							useFixedDomain: false,
							useNiceScale: false,
							horizontalOff: false,
							verticalOff: true,
							unzoomEventType: 'dblclick.zoom'
						}
					}
				}
			};
		}
	}
})();